import { isEmpty } from "ramda";
import { Alert, Icon, Tooltip, Typography } from "@/components/atoms";

const DISPATCH_SETTINGS_INFO = `Jobs are dispatched based on the earliest time set.

If multiple tiers have the exact same dispatch time, the following fallback order will apply:

Own Drivers — Tier 1
Own Drivers — Tier 2
Own Drivers — Tier 3
Private Network
Public Network`;

const InfoIcon = ({ content }: { content: string | JSX.Element }) => (
  <Tooltip content={content} placement="right" interactive maxWidth={400}>
    <Icon name="InfoCircle" variant="Bold" size="md" className="text-neutral-dark-gray" />
  </Tooltip>
);

export const DispatchSettingsInfoIcon = () => (
  <InfoIcon
    content={
      <Typography variant="action" className="whitespace-pre-line leading-4 text-white">
        {DISPATCH_SETTINGS_INFO}
      </Typography>
    }
  />
);

export const OffloadingInfoIcon = () => (
  <InfoIcon content="Changes to the hold time will only apply when Offloading is enabled." />
);

export const renderDispatchTime = (time?: string | number, timeFrame?: string) => {
  if (time && timeFrame) {
    return `${time} ${timeFrame}${Number(time) !== 1 ? "s" : ""}`;
  }

  return null;
};

export const renderErrors = (errors: string[]) => {
  return !isEmpty(errors) ? (
    <div className="mt-4 space-y-3">
      {errors.map((error, i) => (
        <Alert key={i} type="danger" message={error} className="w-full" />
      ))}
    </div>
  ) : null;
};
